var exports = {
  "n": "x127c5a35--48594d--link",
  "x": "x127c5a35--48594d--button",
};

module.exports = exports;
